import React from 'react';
import { Button } from '../../../components/Bootstrap';
import { States } from '../../../constants';
import { VenueInput } from './../../../globalTypes';
import { Form } from '../../../components';
import { VenueQuery_venue as Venue } from './__generated__/VenueQuery';

const schema: any = {
  properties: {
    firstName: {
      id: '/properties/firstName',
      type: 'string',
      title: 'First Name',
    },
    lastName: {
      id: '/properties/lastName',
      type: 'string',
      title: 'Last Name',
    },
    street1: {
      id: '/properties/street1',
      type: 'string',
      title: 'Address',
    },
    city: {
      id: '/properties/city',
      type: 'string',
      title: 'City',
    },
    state: {
      id: '/properties/state',
      type: 'string',
      title: 'State',
      enum: Object.keys(States),
      enumNames: Object.values(States),
    },
    zip: {
      id: '/properties/zip',
      type: 'string',
      title: 'Zip Code',
    },
    phone: {
      id: '/properties/phone',
      type: 'string',
      title: 'Phone Number',
      pattern: '^[0-9()\\-\\.\\s]+$',
    },
  },
  type: 'object',
};

interface OwnerSectionProps {
  venue: Venue;
  editing: boolean;
  onSubmit(data: VenueInput);
  handleCancel();
}

export class OwnerSection extends React.Component<OwnerSectionProps, any> {
  getField(name) {
    if (this.props.venue.ownerAddress) {
      return this.props.venue.ownerAddress[name];
    }

    return null;
  }

  onSubmit = (result) => {
    const { formData: data } = result;
    const { ownerDOB, firstName, lastName, ...address } = data;

    const submitData: any = {
      ownerDOB,
      pointOfContactFirstName: firstName,
      pointOfContactLastName: lastName,
    };

    submitData.ownerAddress = address;
    const id = this.getField('id');
    if (id) {
      submitData.ownerAddress.id = id;
    }

    this.props.onSubmit(submitData);
  };

  renderForm() {
    const formData = {
      firstName: this.props.venue.pointOfContactFirstName,
      lastName: this.props.venue.pointOfContactLastName,
      street1: this.getField('street1'),
      city: this.getField('city'),
      state: this.getField('state'),
      zip: this.getField('zip'),
      phone: this.getField('phone'),
      ownerDOB: this.props.venue.ownerDOB,
    };

    if (this.props.venue.paymentProcessor === 'braintree') {
      schema.properties.ownerDOB = {
        type: 'string',
        format: 'date',
        title: 'Date of Birth',
      };
    }

    return (
      <Form onSubmit={this.onSubmit} formData={formData} schema={schema}>
        <div>
          <Button onClick={this.props.handleCancel} color='link'>
            Cancel
          </Button>
          <Button type='submit' color='primary' className='btn--rounded-padded'>
            Submit
          </Button>
        </div>
      </Form>
    );
  }

  renderNonForm() {
    const isFP = this.props.venue.paymentProcessor === 'freedompay';

    return (
      <div>
        <p className='manage-venue-copy'>
          {this.props.venue.pointOfContactFirstName} {this.props.venue.pointOfContactLastName}
        </p>
        <p className='manage-venue-copy'>{this.getField('street1')}</p>
        <p className='manage-venue-copy'>
          {this.getField('city')}, {this.getField('state')} {this.getField('zip')}
        </p>
        <p className='manage-venue-copy'>{this.getField('phone')}</p>
        {!isFP && <p className='manage-venue-copy'>{this.props.venue.ownerDOB}</p>}
      </div>
    );
  }

  render() {
    if (this.props.editing) {
      return this.renderForm();
    } else {
      return this.renderNonForm();
    }
  }
}
